
// ** Third Party Components
import { X } from "lucide-react"

// ** UI Components
import { Badge } from "@components/common/badge"

// ** Custom Hooks
import useTranslator from "@hooks/use-translator"
import { useFilesView } from "@pma/hooks/use-files-view"

export default function ActiveFilters() {
  const { translate } = useTranslator()
  const { search, fileTypes, setSearch, setSortingObj, setFileTypes } = useFilesView()

  const searchArray: string[] = []
  if (search !== "") searchArray.push(search)
  if (fileTypes.length > 0) searchArray.push(...fileTypes)

  if (searchArray.length === 0) return null

  const clearAll = () => {
    setSearch("")
    setSortingObj({ sorting: "name", order: "asc" })
    setFileTypes([])
  }

  return (
    <div className="flex items-center gap-1 p-2 transition-all ease-in-out">
      <div className="flex items-center gap-2">
        <small>{translate("Active filter")}:</small>
        {searchArray.map((item, index) => (
          <Badge
            variant={index % 2 === 1 ? "outline" : "default"}
            className="font-thin"
            key={index}
          >
            {translate(item)}
          </Badge>
        ))}
      </div>
      <X size={16} className="cursor-pointer text-red-500" onClick={clearAll} />
    </div>
  )
}